require('./bootstrap');

window.Vue = require('vue');

window.backstretch = require('jquery-backstretch');

window.BootstrapVue = require('bootstrap-vue');
window.Vue.use(BootstrapVue);

Vue.component('backstretch', require('./components/Backstretch.vue').default);
Vue.component('blocks', require('./components/SizzledeckBlocks.vue').default);
Vue.component('tracking', require('./components/TrackingComponent.vue').default);





/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});

